import { TextField } from "~components";
import type { NumberAnswerType } from "~onboarding/utils/types";

type NumberAnswerProps = Omit<NumberAnswerType, "type"> & {
  /**
   * The value of the entered number.
   */
  value?: string;
  /**
   * When entering text, pass the `value` to the parent.
   */
  onChange: (value?: string) => void;
  /**
   * Disables the editability of the answer.
   */
  isReadOnly?: boolean;
};

export function NumberAnswer(props: NumberAnswerProps) {
  const { value, onChange, isReadOnly, label, placeholder } = props;

  return (
    <TextField
      type="number"
      value={value}
      // An empty string is considered an unanswered question
      onChange={(value) => onChange(value === "" ? undefined : value)}
      isDisabled={isReadOnly}
      label={label}
      placeholder={placeholder}
    />
  );
}
